import React from "react";
import {Button} from "../../basic-ui-components/button/base/button.component";
import {OnErrorBox} from "./boxes/on-error.box";
import {OnErrorIconBox} from "./boxes/on-error-icon.box";
import {OnErrorTitleBox} from "./boxes/on-error-title.box";
import {OnErrorMessageBox} from "./boxes/on-error-message.box";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {OnErrorButtonsBox} from './boxes/on-error-buttons.box';



export interface OnErrorComponentProps{
  title?: string;
  message?: string;
  onRetryButtonClick: () => void;
  onCloseButtonClick: () => void;
}

export class OnErrorComponent extends OrbitComponent<OnErrorComponentProps> {


    render() {
        const title = this.props.title || this.services.translation.translate("CANT_CONNECT_ERROR_TITLE");
        const message = this.props.message || this.services.translation.translate("CANT_CONNECT_ERROR_MESSAGE");
        return (
            <OnErrorBox>
                <OnErrorIconBox>
                    <img src={this.services.theme.currentTheme.assets.images.broken_link_icon_png.toString()} alt={message}/>
                </OnErrorIconBox>
                <OnErrorTitleBox>{title}</OnErrorTitleBox>
                <OnErrorMessageBox>{message}</OnErrorMessageBox>
                <OnErrorButtonsBox>
                    <Button
                        preset="secondary"
                        className="cy-close-on-error"
                        onClick={() => this.props.onCloseButtonClick()}
                        sizeVariant="xs"
                        noRemUnits
                    >
                        {this.services.translation.translate("CLOSE")}
                    </Button>
                    <Button
                        preset="primary"
                        className="cy-retry-on-error"
                        onClick={() => this.props.onRetryButtonClick()}
                        sizeVariant="xs"
                        noRemUnits
                    >
                        {this.services.translation.translate("RETRY")}
                    </Button>
                </OnErrorButtonsBox>

            </OnErrorBox>
        );
    }
}
